export const STEP_TITLES = {
  PULSARA_SEARCH: 'Pulsara Search',
  PATIENT_SEARCH_FORM: 'Patient Search Form',
  PATIENT_SEARCH_RESULTS: 'Patient Search Results',
  PATIENT_MATCH: 'Patient Match',
  PATIENT_CONFLICT: 'Patient Conflict',
  IMPORT: 'Import',
}

export const STEP_IDS = {
  PULSARA_SEARCH: 1,
  PATIENT_MATCH: 2,
  IMPORT: 3,
} as const

export const PULSARA_STEPS = [
  {
    id: STEP_IDS.PULSARA_SEARCH,
    title: STEP_TITLES.PULSARA_SEARCH,
  },
  {
    id: STEP_IDS.PATIENT_MATCH,
    title: STEP_TITLES.PATIENT_MATCH,
  },
  {
    id: STEP_IDS.IMPORT,
    title: STEP_TITLES.IMPORT,
  },
]

export const PATIENT_MATCH_SUB_STEP_IDS = {
  PATIENT_SEARCH_FORM: 1,
  PATIENT_SEARCH_RESULTS: 2,
  PATIENT_CONFLICT: 3,
} as const

export const IMPORT_SUB_STEP_IDS = {
  VITALS_LABS: 1,
  ATTACHMENTS: 2,
} as const

export const IMPORT_SUB_STEPS = [
  {
    id: IMPORT_SUB_STEP_IDS.VITALS_LABS,
    title: 'Vitals & Labs',
  },
  {
    id: IMPORT_SUB_STEP_IDS.ATTACHMENTS,
    title: 'Attachments',
  },
]
